import { render, staticRenderFns } from "./WelcomeStartPage.vue?vue&type=template&id=521c7825&scoped=true"
import script from "./WelcomeStartPage.vue?vue&type=script&lang=ts"
export * from "./WelcomeStartPage.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeStartPage.vue?vue&type=style&index=0&id=521c7825&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c7825",
  null
  
)

export default component.exports